module.exports = __webpack_public_path__ + "prod/1.42.2/img/faq0.772e0b0a.png";